import React from 'react';
import DatePicker from 'react-datepicker';
import { ErrorMessage } from 'formik';
import { FormGroup, Label } from 'reactstrap';
import 'react-datepicker/dist/react-datepicker.css';
import ErrorBoundary from 'components/common/ErrorBoundary';
import { RiCalendar2Line } from 'react-icons/ri';

const FormikDateRangePicker = (props) => {
  const {
    id,
    form,
    field,
    label,
    isRequired,
    placeholder,
    inputprops,
    // dateFormat,
  } = props;
  const { touched, errors, setFieldValue, setFieldTouched } = form;

  const formatedDate = field?.value ? new Date(field?.value) : new Date();

  // if (field.value) {
  //   if (dateFormat) {
  //     formatedDate = new Date(
  //       moment.utc(field.value, dateFormat).format('YYYY-MM-DD')
  //     );
  //   } else {
  //     // formatedDate = new Date(moment.utc(field.value).format('YYYY-MM-DD'));
  //     formatedDate = new Date(field.value);
  //   }
  // }
  const handleChange = (date) => {
    setFieldValue(field.name, date, true);
  };
  const onBlur = () => {
    setFieldTouched(field.name, true, true);
  };

  return (
    <ErrorBoundary>
      <FormGroup className="flex-grow-1">
        <Label id={field.name}>
          {label}
          {isRequired && <span className="text-danger"> *</span>}
        </Label>
        <div
          className={
            errors[field.name] && touched[field.name] && 'select-error'
          }
        >
          <div className="position-relative">
            <DatePicker
              peekNextMonth
              dateFormat="dd/MM/yyyy"
              placeholderText={placeholder}
              yearDropdownItemNumber={15}
              id={id}
              invalid={Boolean(touched[field.name] && errors[field.name])}
              selected={formatedDate}
              onChange={handleChange}
              name={field.name}
              dropdownMode="select"
              className="form-control"
              onClickOutside={onBlur}
              autoComplete="off"
              {...inputprops}
              {...props}
            />
            <RiCalendar2Line
              size={20}
              color="#8F8D8B"
              style={{ top: '3px' }}
              className="position-absolute end-0 mt-1"
            />
          </div>
        </div>
        <ErrorMessage
          name={field.name}
          render={(msg) => <div className="text-danger f-12">{msg}</div>}
        />
      </FormGroup>
    </ErrorBoundary>
  );
};
export default FormikDateRangePicker;

// import React, { useState } from 'react';
// import DateRangePicker from 'react-bootstrap-daterangepicker';
// import { ErrorMessage } from 'formik';
// import { FormGroup, Label } from 'reactstrap';
// import 'bootstrap-daterangepicker/daterangepicker.css';

// const FormikDateRangePicker = ({
//   field: { name },
//   form: { setFieldValue },
//   label,
//   ...rest
// }) => {
//   const [, setStartDate] = useState(null);

//   const handleChange = (date) => {
//     setFieldValue(name, date, true);
//     setStartDate(date);
//   };
//   return (
//     <FormGroup className="flex-grow-1">
//       {label && (
//         <Label for={name} className="d-block">
//           {label}
//         </Label>
//       )}
//       <DateRangePicker
//         onCallback={(start) => {
//           if (start) {
//             handleChange(new Date(start));
//           }
//         }}
//         {...rest}
//       >
//         <input type="text" className="form-control col-8" />
//       </DateRangePicker>

//       <ErrorMessage
//         name={name}
//         render={(msg) => <div className="text-danger f-12">{msg}</div>}
//       />
//     </FormGroup>
//   );
// };
// export default FormikDateRangePicker;
